import React, {createContext, useEffect, useId, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import axios from 'axios';
import * as constants from 'constants/index.js';
import {formatDate, validateForm} from 'constants/index.js';
import Cookies from "js-cookie";

import {Col, FormGroup, Input, Row,} from "reactstrap";
import notify from "@utils/notify";

export const Context = createContext({});

export const Provider = props => {
  const { id, children } = props;
  
  const image = useRef(null);
  const history = useHistory();

  const [token, setToken] = useState('');
  const [dealer, setDealer] = useState('');
  const [tab, setTab] = useState('profile');
  const [imageFile, setImageFile] = useState(null);
  const [isNotValid, setIsNotValid] = useState(true);

  const [profileErrors, setProfileErrors] = useState('');
  const [detailErrors, setDetailErrors] = useState('');
  const [modulesErrors, setModulesErrors] = useState('');
  const [financialErrors, setFinancialErrors] = useState('');
  const [frontendErrors, setFrontendErrors] = useState('');

  const [dealerProfile, setDealerProfile] = useState('');
  const [dealerLanding, setDealerLanding] = useState('');
  const [editorState, setEditorState] = useState(null);
  const [dealerFinancial, setDealerFinancial] = useState('');
  const [countries, setCountries] = useState([]);
  const [counties, setCounties] = useState([]);
  const [availableDealerAdminUser, setAvailableDealerAdminUser] = useState([]);
  const [assignedUser, setAssignedUser] = useState('');
  const [modules, setModules] = useState('');
  const [assignedModules, setAssignedModules] = useState('');

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/dealer/${id}`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        const data = response.data.data
        setDealer({
          ...data,
          user_id: data.assignedUser ? data.assignedUser.id : ''
        });
     if (data.dealerProfile) {
       setDealerProfile({
         ...data.dealerProfile,
         date_of_birth: data.dealerProfile.date_of_birth ? formatDate(data.dealerProfile.date_of_birth) : '',
       });
       setDealerLanding(data.dealerLanding);
       setEditorState(data.dealerLanding?.description);
       setDealerFinancial({
         ...data.dealerFinancial,
         contract_deposit_at: data.dealerFinancial.contract_deposit_at ? formatDate(data.dealerFinancial.contract_deposit_at) : '',
         contract_starts_at: data.dealerFinancial.contract_starts_at ? formatDate(data.dealerFinancial.contract_starts_at) : '',
         contract_signed_at: data.dealerFinancial.contract_signed_at ? formatDate(data.dealerFinancial.contract_signed_at) : '',
       });
       setCountries(data.countries);
       setCounties(data.counties);
       setAvailableDealerAdminUser(data.availableDealerAdminUser);
       setAssignedUser(data.assignedUser);
       setModules(data.modules);
       setAssignedModules(data.assignedModules);
     }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response.data.message ? error.response.data.message : error.response.statusText)
        }
        setTimeout(() => {
          history.push('/admin/dealer');
        }, 1500);
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const handleChange = (files) => {
    setImageFile(files[0]);
  }

  const band = [null, 'null', undefined];

  const updateProfile = () => {
    let formData = new FormData();
    formData.append('dealer_id',                  id);
    formData.append('name',                       band.includes(dealerProfile.name)                      ? '': dealerProfile.name);
    formData.append('address',                    band.includes(dealerProfile.address)                   ? '': dealerProfile.address);
    formData.append('contact_person',             band.includes(dealerProfile.contact_person)            ? '': dealerProfile.contact_person);
    formData.append('place_of_birth',             band.includes(dealerProfile.place_of_birth)            ? '': dealerProfile.place_of_birth);
    formData.append('license_no',                 band.includes(dealerProfile.license_no)                ? '': dealerProfile.license_no);
    formData.append('business_name',              band.includes(dealerProfile.business_name)             ? '': dealerProfile.business_name);
    formData.append('office_city',                band.includes(dealerProfile.office_city)               ? '': dealerProfile.office_city);
    formData.append('office_post_code',           band.includes(dealerProfile.office_post_code)          ? '': dealerProfile.office_post_code);
    formData.append('office_contact_phone',       band.includes(dealerProfile.office_contact_phone)      ? '': dealerProfile.office_contact_phone);
    formData.append('office_email_for_enquiries', band.includes(dealerProfile.office_email_for_enquiries)? '': dealerProfile.office_email_for_enquiries);
    formData.append('phone_number',               band.includes(dealerProfile.phone_number)              ? '': dealerProfile.phone_number);
    formData.append('email',                      band.includes(dealerProfile.email)                     ? '': dealerProfile.email);
    formData.append('fiscal_code',                band.includes(dealerProfile.fiscal_code)               ? '': dealerProfile.fiscal_code);
    formData.append('bank',                       band.includes(dealerProfile.bank)                      ? '': dealerProfile.bank);
    formData.append('bank_sort_code',             band.includes(dealerProfile.bank_sort_code)            ? '': dealerProfile.bank_sort_code);
    formData.append('account_number',             band.includes(dealerProfile.account_number)            ? '': dealerProfile.account_number);
    formData.append('account_name',               band.includes(dealerProfile.account_name)              ? '': dealerProfile.account_name);
    if (imageFile) {
      formData.append('logo', imageFile);
    }
    if (dealerProfile.date_of_birth) {
      formData.append('date_of_birth', dealerProfile.date_of_birth === 'null'? '': dealerProfile.date_of_birth);
    }
    if (dealerProfile.country_of_birth_id) {
      formData.append('country_of_birth_id', dealerProfile.country_of_birth_id === 'null'? '': dealerProfile.country_of_birth_id);
    }
    if (dealerProfile.county_id) {
      formData.append('county_id', dealerProfile.county_id === 'null'? '': dealerProfile.county_id);
    }
    if (dealerProfile.is_public_listed) {
      formData.append('is_public_listed', dealerProfile.is_public_listed === true? 1: 0);
    }

    axios({
      method: 'POST',
      url: constants.API_URL + '/dealer/profile',
      headers: {
        'accept': 'application/json',
        Authorization: 'Bearer ' + token,
        'Content-Type': `multipart/form-data`,
      },
      data: formData
    })
      .then(response => {
        if (response.status === 200) {
          setProfileErrors('');
          let data = response.data.data;
          setDealerProfile({
            ...data,
            date_of_birth: data.date_of_birth? formatDate(data.date_of_birth): '',
          });
          notify.success(response.data.message);
        }
      })
      .catch(error => {
        console.error('error :: ', error.response);
        if (error.response.status === 422) {
          let errors = error.response.data.errors;
          setProfileErrors(errors);
          return
        }
        notify.warning(error.response ? error.response.statusText : 'Error occurred.');
      })
  }

  useEffect(() => {
    const required = ['contact_person','phone_number','name','address','account_number','bank','account_name','bank_sort_code','fiscal_code','email']
    setIsNotValid(!validateForm(required,dealerProfile));
  }, [dealerProfile])

  const updateDetail = () => {
    axios({
      method: 'PUT',
      url: constants.API_URL + '/dealer-dealers/' + id,
      headers: {
        Authorization: 'Bearer ' + token,
      },
      data: dealer
    })
      .then(response => {
        if (response.status === 200) {
          setDetailErrors('');
          let data = response.data;
          console.log('response detail data :: ', data);
          setDealer({
            ...data.data.dealer,
            user_id: data.data.assignedUser? data.data.assignedUser.id: ''
          });
          setAssignedUser(data.data.assignedUser);
          notify.success(response.data.message);
        }
      })
      .catch(error => {
        console.error('error :: ', error);
        if (error.response && error.response.status === 422) {
          let errors = error.response.data.errors;
          setDetailErrors(errors);
          return
        }
        notify.error(error.response? error.response.statusText: 'Error occurred.');
      })
  }

  const updateModules = () => {
    let modules = [];
    Object.keys(assignedModules).forEach((key) => {
      let element = {
        module_type: key,
        value: assignedModules[key] && assignedModules[key].value? assignedModules[key].value: '',
        is_enabled: assignedModules[key] && assignedModules[key].is_enabled? assignedModules[key].is_enabled: ''
      }
      modules.push(element);
    })

    if (modules.length > 0) {
      let body = {
        modules: modules
      }
      axios({
        method: 'POST',
        url: constants.API_URL + '/dealer/' + dealer.slug + '/modules',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: body
      })
        .then(response => {
          if (response.status === 200) {
            console.log('response module data :: ', response.data);
            notify.success(response.data.message);
          }
        })
        .catch(error => {
          console.error('error :: ', error);
          if (error.response.status === 422) {
            let errors = error.response.data.errors;
            setModulesErrors(errors);
  
            let notification = '';
            let count = 0;
            for (var key in errors) {
              count ++;
              notification += '<b>' + count + '. </b>' + errors[key] + '<br />';
            }    
            notify.error(notification);
          }
        })
    }
  }

  const updateFinancial = () => {
    axios({
      method: 'PUT',
      url: constants.API_URL + '/dealer/financial',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      data: dealerFinancial
    })
      .then(response => {
        if (response.status === 200) {
          setFinancialErrors('');
          let data = response.data.data;
          console.log('response financial data :: ', response.data);
          setDealerFinancial({
            ...data,
            contract_deposit_at: data.contract_deposit_at? formatDate(data.contract_deposit_at): '',
            contract_starts_at: data.contract_starts_at? formatDate(data.contract_starts_at): '',
            contract_signed_at: data.contract_signed_at? formatDate(data.contract_signed_at): '',
          });

          notify.success(response.data.message);
        }
      })
      .catch(error => {
        console.error('error :: ', error);
        if (error.response.status === 422) {
          let errors = error.response.data.errors;
          setFinancialErrors(errors);
          return
        }
        notify.error(error.response ? error.response.statusText : 'Error occurred.');
      })
  }

  const updateFront = () => {
    axios({
      method: 'PUT',
      url: constants.API_URL + '/dealer/landing',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      data: dealerLanding
    })
      .then(response => {
        if (response.status === 200) {
          let data = response.data.data;
          console.log('response financial data :: ', response.data);
          setDealerLanding(data);
          notify.success(response.data.message);
        }
      })
      .catch(error => {
        console.error('error :: ', error);
        if (error.response.status === 422) {
          let errors = error.response.data.errors;
          setFrontendErrors(errors);

          let notification = '';
          let count = 0;
          for (var key in errors) {
            count ++;
            notification += '<b>' + count + '. </b>' + errors[key] + '<br />';
          }    
          notify.error( notification);
        }
      })
  }



  const OptionTag = (options) => {
    return Object.keys(options).map((key) => {
      return (
        <option value={key} key={key}>{options[key]}</option>
      )
    })
  }

  const AllTag = (modules) => {
    const id = useId();
    return Object.keys(modules).map((key) => {
      return (
        <div key={key}>
          <FormGroup>
            <label
              className="form-control-label"
              htmlFor={id}
            >
              {key.charAt(0).toUpperCase() + key.slice(1)}
              </label>
            <Input
              id={id}
              type="select"
              value={assignedModules[key] && assignedModules[key].value ? assignedModules[key].value : ''}
              onChange={(e) => setAssignedModules({
                ...assignedModules,
                [key]: {
                  ...assignedModules[key],
                  value: e.target.value
                }
              })}
            >
              <option value="">-</option>
              { OptionTag(modules[key]) }
            </Input>
          </FormGroup>
          <FormGroup>
            <label
              className="form-control-label"
              htmlFor="detail_is_active"
            >
              Is enabled
              </label>
            <Row>
              <Col>
                <label className="custom-toggle">
                  <input
                    type="checkbox"
                    checked={assignedModules[key] && assignedModules[key].is_enabled? true: false}
                    onChange={() => setAssignedModules({
                      ...assignedModules,
                      [key]: {
                        ...assignedModules[key],
                        is_enabled: assignedModules[key] && assignedModules[key].is_enabled? false: true
                      }
                    })}
                  />
                  <span
                    className="custom-toggle-slider rounded-circle"
                    data-label-off="No"
                    data-label-on="Yes"
                  />
                </label>
              </Col>
            </Row>
          </FormGroup>
        </div>
      );
    });
  }

  const dealersContext = {
    id,
    image,
    history,
    token, setToken,
    dealer, setDealer,
    tab, setTab,
    isNotValid,
    imageFile, setImageFile,
    profileErrors, setProfileErrors,
    detailErrors, setDetailErrors,
    modulesErrors, setModulesErrors,
    financialErrors, setFinancialErrors,
    frontendErrors, setFrontendErrors,  
    dealerProfile, setDealerProfile,
    dealerLanding, setDealerLanding,
    editorState,
    dealerFinancial, setDealerFinancial,
    countries, setCountries,
    counties, setCounties,
    availableDealerAdminUser, setAvailableDealerAdminUser,
    assignedUser, setAssignedUser,
    modules, setModules,
    assignedModules, setAssignedModules,
    handleChange,
    updateProfile,
    updateDetail,
    updateModules,
    updateFinancial,
    updateFront,
    formatDate,
    OptionTag,
    AllTag
  };

  return <Context.Provider value={dealersContext}>{children}</Context.Provider>
}

export const { Consumer } = Context;